import axios from 'axios';
import { getAuthToken } from './auth';

export const createAxiosInstance = (baseURL?: string) => {
    const instance = axios.create({
        baseURL: baseURL || 'https://api.beta.learning.robotics.amazon.dev/',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    instance.interceptors.request.use(async (config) => {
        config.headers.Authorization = await getAuthToken();
        return config;
    });

    return instance;
};
